import CheckCircle from "@assets/images/check-circle.svg";
import InfoIcon from "@assets/images/info.png";
import XCircle from "@assets/images/x-circle.svg";
import { Box } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import {
  InquiryOrderConfirmationStatus,
  // CustomerOrderConfirmationFilterInput,
  SapOrderConfirmationInput,
  useListOrderConfirmationSapQuery
} from "@saleor/graphql";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
import usePaginationLocal from "@saleor/hooks/usePaginationLocal";
import OrderConfirmListTableCustomer from "@saleor/OrderConfirm/components/OrderConfirmListTableCustomer";
import OrderFilterSectionCustomer from "@saleor/OrderConfirm/components/OrderFilterSectionCustomer";
import {
  OrderConfirmListSortField,
  OrderConfirmListUrl,
  OrderConfirmUrlQueryParams
} from "@saleor/OrderConfirm/urls";
import { ListViews } from "@saleor/types";
import { getSortParams, getSortUrlVariables } from "@saleor/utils/sort";
import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";

export interface IOrderConfirmProps {
  params: OrderConfirmUrlQueryParams;
}

function SectionMessage(props) {
  return (
    <Box display={"flex"} justifyItems="center">
      <img src={props.icon} alt="info" />
      <Box ml={1}>
        <MyTypography
          variant="body3"
          style={{
            color: props.color
          }}
          color={props.color}
        >
          {props.message}
        </MyTypography>
      </Box>
    </Box>
  );
}

const OrderConfirmViewCustomer: React.FC<IOrderConfirmProps> = ({ params }) => {
  // TODO CustomerOrderConfirmationFilterInput
  const [filter, setFilter] = useState<any>({});
  const [filterSAP, setFilterSAP] = useState<SapOrderConfirmationInput>(
    undefined
  );
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const intl = useIntl();
  const navigate = useNavigator();

  const { updateListSettings, settings } = useListSettings(
    ListViews.ORDER_CONFIRM_CUSTOMER
  );

  const mapProductGroup = productArr => {
    if (!productArr || !productArr.length) {
      return undefined;
    }
    return productArr;
  };

  const handleChangeFilter = filterObj => {
    if (Object.keys(filterObj).length === 0) {
      setFilter({});
      setIsSearched(false);
      return;
    }
    const data = {
      soNo: filterObj.soNo || undefined,
      soldTo: filterObj.soldTo || undefined,
      companyName:
        (filterObj?.companies?.length || 0) > 0
          ? filterObj.companies
          : undefined,
      poNo: filterObj.poNo || undefined,
      material: filterObj.material || undefined,
      distributionChannel: filterObj.channel || undefined,
      status: (filterObj.status as unknown) as InquiryOrderConfirmationStatus,
      materialGroup:
        filterObj.productGroup.length > 0 ? filterObj.productGroup : undefined,
      orderCreateDate: filterObj.orderCreateDate || undefined
    };
    setIsSearched(true);
    setFilter({ ...data });
  };

  useEffect(() => {
    const _filterSAP: SapOrderConfirmationInput = {
      soldTo: filter.soldTo ? [filter.soldTo.substr(0, 10)] : undefined,
      materialNoMaterialDescription: filter.material
        ? filter.material
        : undefined,
      createDate:
        filter?.orderCreateDate?.gte && filter?.orderCreateDate?.lte
          ? {
              gte: filter?.orderCreateDate?.gte,
              lte: filter?.orderCreateDate?.lte
            }
          : undefined,
      channel: filter.distributionChannel,
      saleOrg: filter.companyName,
      productGroup: mapProductGroup(filter.materialGroup),
      poNo: filter.poNo,
      soNo: filter.soNo,
      status:
        ((filter.status as unknown) as InquiryOrderConfirmationStatus) ||
        undefined
    };
    setFilterSAP(_filterSAP);
  }, [filter]);

  const {
    data: dataSearch,
    loading: loadingSearch
  } = useListOrderConfirmationSapQuery({
    displayLoader: true,
    variables: {
      filter: filterSAP
    },
    skip:
      !filterSAP ||
      (filterSAP && !Object.values(filterSAP).filter(value => value).length)
  });

  const paramSort = getSortParams(params);
  const dataSearchList = useMemo(() => {
    if (dataSearch?.listOrderConfirmationSap) {
      const listToSort = [...dataSearch.listOrderConfirmationSap];
      switch (paramSort.sort) {
        case OrderConfirmListSortField.soNo:
          if (paramSort.asc) {
            listToSort.sort((itemA, itemB) =>
              itemA.soNo.localeCompare(itemB.soNo)
            );
          } else {
            listToSort.sort((itemA, itemB) =>
              itemB.soNo.localeCompare(itemA.soNo)
            );
          }
      }
      return listToSort;
    }
    return [];
  }, [dataSearch?.listOrderConfirmationSap, filterSAP, paramSort?.asc]);

  const {
    currentData,
    next,
    prev,
    toFirst,
    toLast,
    disableNext,
    disablePrev,
    lastestPageItemNumber
  } = usePaginationLocal(dataSearchList, settings.rowNumber);

  const handleSort = field => {
    toFirst();
    navigate(
      OrderConfirmListUrl({
        ...params,
        ...getSortUrlVariables(field, params)
      }),
      { replace: true }
    );
  };

  const message = useMemo(() => {
    if (loadingSearch) {
      return {
        icon: InfoIcon,
        message: intl.formatMessage({
          defaultMessage: "กรุณากรอกข้อมูลและกดค้นหา"
        }),
        color: "#555555"
      };
    }
    if (!isSearched) {
      return {
        icon: InfoIcon,
        message: intl.formatMessage({
          defaultMessage: "กรุณากรอกข้อมูลและกดค้นหา"
        }),
        color: "#555555"
      };
    }
    if (isSearched && !dataSearch?.listOrderConfirmationSap?.length) {
      return {
        icon: XCircle,
        message: intl.formatMessage({
          defaultMessage: "ไม่พบรายการที่เกี่ยวข้อง"
        }),
        color: "#FF2600"
      };
    }
    return {
      icon: CheckCircle,
      message: intl.formatMessage({
        defaultMessage: "พบรายการที่เกี่ยวข้อง"
      }),
      color: "#28A745"
    };
  }, [dataSearch?.listOrderConfirmationSap?.length, isSearched, loadingSearch]);

  return (
    <>
      <OrderFilterSectionCustomer
        message={<SectionMessage {...message} />}
        handleChangeFilter={handleChangeFilter}
        listOrder={dataSearchList}
        loading={loadingSearch}
      />

      {!loadingSearch && dataSearchList.length > 0 ? (
        <OrderConfirmListTableCustomer
          settings={settings}
          disabled={loadingSearch}
          data={currentData()}
          onNextPage={next}
          onPreviousPage={prev}
          onUpdateListSettings={updateListSettings}
          onNextLastPage={toLast}
          onPreviousFirstPage={toFirst}
          totalCount={dataSearch?.listOrderConfirmationSap?.length}
          latestPageItemNumber={lastestPageItemNumber}
          pageInfo={{
            hasPreviousPage: !disablePrev(),
            hasNextPage: !disableNext()
          }}
          loading={loadingSearch}
          onSort={handleSort}
          sort={getSortParams(params)}
          onRowClick={() => null}
        />
      ) : null}
    </>
  );
};

export default OrderConfirmViewCustomer;
